/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../components/ScrollAware';
import { AppHeaderScrollableText } from '../components/appNav/AppHeaderScrollable';

import { validateEmail } from '../../utilities/Validators';
import ContentWrapper from '../components/ContentWrapper';
import UserService from '../../apiServices/UserService';

import { Card, Inputs } from '../../bphComponents/bundle';

interface Props {
  defaultEmail: string;
  onChangeEmail?(v): void;
  submitEmail(v, cb): void;
  goBack(): void;
}
interface State {
  email: string;
  isEmailValid: boolean;
  isEmailInUse: boolean;
  errorMessage: any;
  submitAttemptCount: number;
}
const ChangeEmail: React.FC<Props> = (props) => {
  const { submitEmail, onChangeEmail, goBack } = props;

  const [state, setState] = React.useState<State>({
    email: props.defaultEmail || '',
    isEmailValid: false,
    isEmailInUse: false,
    errorMessage: '',
    submitAttemptCount: 0,
  });

  const handleOnChangeEmail = (value) => {

    setState({
      ...state,
      email: value,
      isEmailValid: validateEmail(value),
    });

    if (onChangeEmail) { onChangeEmail(value); }
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (!state.isEmailValid) {
      setState({
        ...state,
        errorMessage: <FormattedMessage id="error.email-validator.invalid-email.message" />,
        submitAttemptCount: state.submitAttemptCount + 1,
      });
      return;
    }

    UserService.checkEmailExists(state.email, (apiError, exists) => {
      if (exists) {
        setState({
          ...state,
          errorMessage: <FormattedMessage id="error.api-users.error.api-users.400-email-in-use.message" />,
          isEmailInUse: true,
        });
        return;
      }

      submitEmail(state.email, goBack);
    });
  };

  return (
    <div className="temp-app-background-color-OLD">
      <ScrollAwareContext>
        <ScrollAwareAppNavStep
          submitDisabled={!state.isEmailValid}
          onDisabledClick={handleOnSubmit}
          submit={handleOnSubmit}
          cancel={goBack}
          color="white"
        />

        <ContentFrame>
          <ScrollAwareScroller>
            <AppHeaderScrollableText
              id="settingsChangeEmail.title.text"
            />
            <ContentWrapper>
              <Card.CardShape>
                <Card.CardContent>
                  <form onSubmit={handleOnSubmit}>
                    <Inputs.EmailInput
                      isClearable
                      value={state.email}
                      label={<FormattedMessage id="verifyEmailChange.email.field.label" />}
                      onFocus={() => {
                        setState({
                          ...state,
                          errorMessage: '',
                          submitAttemptCount: 0,
                        });
                      }}
                      onChange={(v) => { handleOnChangeEmail(v); }}
                      invalidHint={state.errorMessage}
                      isInvalid={state.isEmailInUse || (!state.isEmailValid && state.submitAttemptCount > 0)}
                      clearValue={() => { handleOnChangeEmail(''); }}
                      name="email"
                      attemptsBeforeInvalidHint={0}
                      initialFocus
                    />
                  </form>
                </Card.CardContent>
              </Card.CardShape>
            </ContentWrapper>
          </ScrollAwareScroller>
        </ContentFrame>
      </ScrollAwareContext>
    </div>
  );
};

export default ChangeEmail;
